<template>
  <v-row class="mx-0 px-0 dense pb-0">
    <v-col cols="12"  class="pb-0 px-0">
      <v-card-title class="px-0 text--black">
        Business Information
      </v-card-title>
      <v-card flat class="grey lighten-4 ">
        <v-card-text class="py-0">
          <!--Start: General phone number-->
          <SocialTextFieldTitle :icon="'mdi-phone-outline'" :title="'General Phone Number'"/>
          <ContactNumber backgroundColor="white" v-model="currentSponsor.generalPhone"/>

          <!--End: General phone number-->
          <!--Start: General email-->
          <SocialTextFieldTitle :title="'General email'" :icon="'mdi-email-outline'"/>
          <v-text-field :rules="emailRules" background-color="white" v-model="currentSponsor.generalEmail" dense outlined
                        validate-on-blur>
          </v-text-field>
          <!--End: General email-->
        </v-card-text>
      </v-card>
      <v-card-title class="px-0 text--black">
        Business Socials
      </v-card-title>
      <v-card flat class="grey lighten-4 px-4">
        <SocialTextFields :required-rules="requiredRules" title="Website" icon="website-icon.svg" label="Website"
                          :value="currentSponsor.website" :url-prefix="urlPrefixes.urlPrefix"
                          @input="currentSponsor.website=$event"
        />
        <SocialTextFields :required-rules="requiredRules" title="Facebook" icon="facebook-icon.svg" label="Facebook"
                          :value="currentSponsor.facebook" :url-prefix="urlPrefixes.facebookUrlPrefix"
                          :can-disabled="true"
                          @input="currentSponsor.facebook=$event"
        />
        <SocialTextFields :required-rules="requiredRules" title="Instagram" icon="instagram-icon.svg"
                          label="Instagram" :value="currentSponsor.instagram"
                          :url-prefix="urlPrefixes.instagramUrlPrefix" :can-disabled="true"
                          @input="currentSponsor.instagram=$event"
        />
        <SocialTextFields :required-rules="requiredRules" title="Twitter" icon="twitter-icon.svg" label="Twitter"
                          :value="currentSponsor.twitter" :url-prefix="urlPrefixes.twitterUrlPrefix"
                          :can-disabled="true"
                          @input="currentSponsor.twitter=$event"
        />
        <SocialTextFields :required-rules="requiredRules" title="LinkedIn" icon="linkedin-icon.svg" label="LinkedIn"
                          :value="currentSponsor.linkedin" :url-prefix="urlPrefixes.linkedinUrlPrefix"
                          :can-disabled="true"
                          @input="currentSponsor.linkedin=$event"
        />
        <SocialTextFields :required-rules="requiredRules" title="YouTube" icon="youtube-icon.svg" label="YouTube"
                          :value="currentSponsor.youtube" :url-prefix="urlPrefixes.youtubeurlPrefix"
                          :can-disabled="true"
                          @input="currentSponsor.youtube=$event"
        />
        <SocialTextFields :required-rules="requiredRules" title="Podcast" icon="podcast-icon.svg" label="Podcast"
                          :value="currentSponsor.podcast" :url-prefix="urlPrefixes.urlPrefix" :can-disabled="true"
                          @input="currentSponsor.podcast=$event"
        />
      </v-card>
    </v-col>
  </v-row>

</template>

<script>
import Sponsor from "@/models/Sponsor";
import {mapGetters} from "vuex";
import ContactNumber from "@/components/inputs/ContactNumber.vue";
import SocialTextFieldTitle from "@/components/MultiConnect/Sponsors/SocialTextFieldTitle.vue";
import SocialTextFields from "@/components/MultiConnect/Sponsors/SocialTextFields.vue";

export default {
  components: {SocialTextFields, SocialTextFieldTitle, ContactNumber},
  computed: {
    ...mapGetters(["currentEvent", "userProfile", "currentSubEvent", "urlPrefixes"]),
  },
  props: {
    currentSponsor: {
      type: Sponsor,
      required: true,
    }
  },
  methods: {
    updateFacebook(value) {
      console.log(value);
      this.currentSponsor.facebook = value;
    }
  },
  watch: {
    "currentSponsor.facebook": function (newVal, oldVal) {
      if (newVal.startsWith(this.urlPrefixes.facebookUrlPrefix)) {
        this.currentSponsor.facebook = this.currentSponsor.facebook.replace(
            this.urlPrefixes.facebookUrlPrefix,
            ""
        );
      }
    },
    "currentSponsor.instagram": function (newVal, oldVal) {
      if (newVal.startsWith(this.urlPrefixes.instagramUrlPrefix)) {
        this.currentSponsor.instagram = this.currentSponsor.instagram.replace(
            this.urlPrefixes.instagramUrlPrefix,
            ""
        );
      }
    },
    "currentSponsor.twitter": function (newVal, oldVal) {
      if (newVal.startsWith(this.urlPrefixes.twitterUrlPrefix)) {
        this.currentSponsor.twitter = this.currentSponsor.twitter.replace(
            this.urlPrefixes.twitterUrlPrefix,
            ""
        );
      }
    },
    "currentSponsor.linkedin": function (newVal, oldVal) {
      if (newVal.startsWith(this.urlPrefixes.linkedinUrlPrefix)) {
        this.currentSponsor.linkedin = this.currentSponsor.linkedin.replace(
            this.urlPrefixes.linkedinUrlPrefix,
            ""
        );
      }
    },
    "currentSponsor.website": function (newVal, oldVal) {
      if (newVal.startsWith(this.urlPrefixes.urlPrefix)) {
        this.currentSponsor.website = this.currentSponsor.website.replace(this.urlPrefixes.urlPrefix, "");
      }
    },
    "currentSponsor.podcast": function (newVal, oldVal) {
      if (newVal.startsWith(this.urlPrefixes.urlPrefix)) {
        this.currentSponsor.podcast = this.currentSponsor.podcast.replace(this.urlPrefixes.urlPrefix, "");
      }
    },
  },
  data() {
    return {
      requiredRules: [(v) => !!v || "This field is required"],
      emailRules: [
        (v) => !!v || "Please enter your email",
        (v) => /.+@.+\..+/.test(v) || "Please enter a valid email address",
      ],
    }
  }
}
</script>